import { render, staticRenderFns } from "./DepartmentInfo.vue?vue&type=template&id=6bd91cd9"
import script from "./DepartmentInfo.vue?vue&type=script&lang=js"
export * from "./DepartmentInfo.vue?vue&type=script&lang=js"
import style0 from "./DepartmentInfo.vue?vue&type=style&index=0&id=6bd91cd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports